import Icon from '@src/v3/components/coreUI/icon';
import Button from '@src/v3/components/coreUI/button';
import * as React from 'react';
import AppleSignin from 'react-apple-signin-auth';

const AppleButton = ({
  onSuccess = () => {
    return;
  },
  isLoading = false,
  disabled = false,
}: {
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-explicit-any
  onSuccess: (token: string, user: any) => void;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleAppleSuccess = (response: any) => {
    onSuccess(response?.authorization?.id_token, response?.user);
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleAppleError = (error: any) => {
    console.error(error);
  };

  return (
    <AppleSignin
      authOptions={{
        clientId: 'com.rentzeme.zeme.web',
        scope: 'email name',
        redirectURI: 'https://dev.rentzeme.com',
        usePopup: true,
      }}
      uiType="dark"
      onSuccess={handleAppleSuccess}
      onError={handleAppleError}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render={(props: any) => (
        <Button
          type="button"
          variant="outline"
          size="xxl"
          className="w-full shadow-none"
          onClick={() => props.onClick()}
          disabled={disabled || isLoading}
          isLoading={isLoading}
          loadingType="dots"
        >
          <Icon iconName="apple" iconProps={{ className: 'w-5 h-5' }} />
          Continue with Apple
        </Button>
      )}
    />
  );
};

export default AppleButton;
